// Runtime config: injected by Docker entrypoint into /config.js at container start.
// Falls back to Vite build-time env vars for local dev (npm run dev).
const runtimeEnv = window.__ENV__ || {};

export const API_URL =
  runtimeEnv.VITE_API_URL ||
  import.meta.env.VITE_API_URL ||
  'http://localhost:3001/api';

export const WS_URL =
  runtimeEnv.VITE_WS_URL ||
  import.meta.env.VITE_WS_URL ||
  'ws://localhost:3001';
